import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectStoreCount, selectPageName } from 'core/selectors/app';
import { selectUserIsIdentified } from 'core/selectors/user';
import hiwHome1 from 'org/assets/images/shopWifi/hiw_home_1.png';
import hiwHome2 from 'org/assets/images/shopWifi/hiw_home_2.png';
import hiwHome3 from 'org/assets/images/shopWifi/hiw_home_3.png';
import hiwHome4 from 'org/assets/images/shopWifi/hiw_home_4.png';
import { triggerWatchHowItWorksIsViewed } from './actions';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';

import { useModal } from 'core/modules/Modal/ModalProvider';

import './ShopWifiHiw.scss';

function ShopWifiHiw({ title }) {
  const storeCount = useSelector(selectStoreCount);
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const pageName = useSelector(selectPageName);
  const isHomePage = pageName === 'h';
  const videoId = 'j0nfjpx0vp';
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userIsIdentified && isHomePage) {
      dispatch(triggerWatchHowItWorksIsViewed());
    }
  }, [isHomePage, userIsIdentified, dispatch]);

  const { openModal } = useModal();

  const clickHandler = () => {
    openModal({
      name: 'mt_hiwVideo',
      params: { videoId },
    });
  };

  return (
    <div className="mn_shopWifiHiw">
      <ContentWrap>
        <SectionTitle title={title || <>Sign in for free to start earning miles today</>}>
          <button onClick={clickHandler} className="mn_hiwVideoLink"> Watch how it works</button>
        </SectionTitle>
        <div className="mn_sectCont">
          <div className="mn_hiwSteps" data-section-id="10438">
            <div className="mn_hiwStep">
              <div className="mn_hiwStepContent">
                <div className="mn_imageWrap">
                  <img
                    src={hiwHome1}
                    alt="Explore"
                  />
                </div>
                <h3>Explore</h3>
                <p>
                  Explore over {storeCount} stores, exclusive offers and bonus promotions, all in one place.
                </p>
              </div>
            </div>
            <div className="mn_hiwStep">
              <div className="mn_hiwStepContent">
                <div className="mn_imageWrap">
                  <img
                    src={hiwHome2}
                    alt="Click"
                  />
                </div>
                <h3>Shop online</h3>
                <p>
                  Shop at the store site and check out as you normally would.
                </p>
              </div>
            </div>
            <div className="mn_hiwStep">
              <span className="mn_hiwStepIcon" id="mn_hiwShopIcon" />
              <div className="mn_hiwStepContent">
                <div className="mn_imageWrap">
                  <img
                    src={hiwHome3}
                    alt="Shop"
                  />
                </div>
                <h3>Shop in-store</h3>
                <p>Link offers to your preferred card. Shop in-store and pay with your linked card.</p>
              </div>
            </div>
            <div className="mn_hiwStep">
              <span className="mn_hiwStepIcon" id="mn_hiwEarnIcon" />
              <div className="mn_hiwStepContent">
                <div className="mn_imageWrap">
                  <img
                    src={hiwHome4}
                    alt="Earn"
                  />
                </div>
                <h3>Earn</h3>
                <p>After your purchase, miles earned will be added to your MileagePlus account.</p>
              </div>
            </div>
          </div>
        </div>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ShopWifiHiw {...props} /></ComponentErrorBoundary>;
